// I want to keep this empty glimmer class to keep the Arguments type as documentation
import Component from '@glimmer/component';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import Button from 'ui-kit/components/button';
import type FormyComponent from '../formy';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    /**
     * The text of the submit button.
     * If missing, it will default to: "ENREGISTRER"
     * */
    submitText?: string;
    formy: FormyComponent;
  };
  Blocks: {
    default: [];
  };
}

// eslint-disable-next-line ember/no-empty-glimmer-component-classes -- intentionally-empty class kept for Args documentation (see top comment)
class FormyActionsComponent extends Component<Signature> {
  <template>
    <div class='[&_.ui.button:first-child]:uppercase' ...attributes>
      {{! The discard link placeholder }}
      {{yield}}

      <Button
        type='submit'
        class='ui right floated primary button'
        data-test-submit-button
        disabled={{changesetGet @formy.args.changeset 'isPristine'}}
      >
        {{if @submitText @submitText 'Enregistrer'}}
      </Button>
    </div>
  </template>
}
export default FormyActionsComponent;
